<template>
  <div class="page-component-wrapper">
    <grid
      :config="gridConfig"
      @handleCustomButtonGrid="onSendEmail"
    />
    <editor
      :disabled="isDisabledForm"
      :config="{id: gridConfig.id, api: 'Contacts/Get/'}"
    />
    <dialog-email
      ref="dialogEmail"
      :data="dataEmail"
      @on-submit-email="onSubmitEmail"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'ContactsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Contacts' */ './Editor'),
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  data () {
    return {
      gridConfig: gridConfig,
      dataEmail: {}
    }
  },
  computed: {
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditCompanies')
    }
  },
  methods: {
    onSendEmail ({ row }) {
      this.setDialogEmailData(row)
      this.$refs.dialogEmail.show()
    },
    onSubmitEmail (data) {
      return ServiceEmailMessages.send(data)
        .then(this.requestSuccessHandler)
        .catch(this.requestErrorHandler)
        .finally(() => {
          this.$refs.dialogEmail.hide()
        })
    },
    setDialogEmailData (data) {
      let emailToList = []
      data.email && emailToList.push(data.email)
      this.dataEmail = {
        emailToList,
        subject: this.L10n('subject-to-contact')
      }
    }
  }
}
</script>
